<template>
    <div class="report-page year-report-page">
        <div class="my-report-top-bar">
            <!-- 0、顶部标题栏部分 -->
            <year-title-bar></year-title-bar>
            <div class="my-report-top-tab year-report-top-tab">
                <span v-for="yearItem in reportYearList" :key="yearItem.id" class="my-report-top-tab-item" :class="{'cur': yearItem.year == curYear}" @click="clickTopYear(yearItem)">{{ yearItem.year }}年</span>
            </div>
            <div class="year-report-top-tab2">
                <span v-for="tabItem in tabList" :key="tabItem.tabId" class="year-report-top-tab-item" :class="{'tab-item-long': tabItem.tabId == 2,'cur': tabItem.tabId == curTab}" @click="clickTopTab(tabItem.tabId)">{{ tabItem.text }}</span>
            </div>
        </div>
        <!-- 1、介绍内容部分 -->
        <div id="yearTopContent" class="year-main-content-box">
            <div class="year-main-content-content">
                <p class="year-main-cc-p" :class="{'p2': pIndex!=0&&pIndex%2==0}" v-for="(pData, pIndex) in curYearReportData.des" v-html="pData"></p>
                <p class="year-main-cc-p2">需要强调的是，有的教派会列出来非常多的刑冲破害等等，以便为大家提供更多的化解之法，知道动机就好。民间关于化太岁的做法多数是传统意义上的美好的期望，甚至比较严重的带有封建迷信和色彩；我们只有在知道运势顺逆的基础上做好更多趋吉避凶的实际选择操作才是关键，事在人为。</p>
            </div>
            <div class="year-content-animal" :class="'year-'+curYear"></div>
        </div>
        <!-- 2、结果部分 -->
        <year-report-result></year-report-result>

        <!-- 4.1、vip解锁按钮 -->
        <vip-year-button v-if="showYearVipBtn && curYearReportData.f_pay == 0" :frompage="'year'"></vip-year-button>
        <!-- 4.2、vip解锁按钮 -->
        <div class="deep-seek-button-fixed" @click="clickDeepSeek">
            <div v-if="showTips" class="deep-seek-tips tips-2"></div>
        </div>
        <!-- 5、弹框 -->
        <report-act-remind-popup></report-act-remind-popup>
        <!-- 6、重新生成弹框 -->
        <report-re-pay-popup></report-re-pay-popup>
        <router-view></router-view>
    </div>
</template>

<script>
import YearTitleBar from '../../layouts/year/YearTitleBar.vue'
import YearReportResult from '../../layouts/year/YearReportResult.vue'
import VipYearButton from '../../components/common/VipYearButton.vue'
import ReportActRemindPopup from '../../layouts/report/ReportActRemindPopup.vue';
import ReportRePayPopup from '../../layouts/report/ReportRePayPopup.vue';
import { MIX, UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
import { YEAR_DOM } from '../../modules/dom';
export default {
    name: 'YearReportPage',
    components: { YearTitleBar, YearReportResult, VipYearButton, ReportActRemindPopup, ReportRePayPopup },
    computed: {
        reportYearList() {
            return this.$store.state.year.reportYearList;
        },
        curYear() {
            return this.$store.state.year.curYear;
        },
        curYearReportData() {
            return this.$store.state.year.curYearReportData;
        },
        showYearVipBtn() {
            return this.$store.state.user.showYearVipBtn;
        }
    },
    data() {
        return {
            showTips: window.localStorage.getItem('h5_fate_ds_year_tips') ? false : true,
            qrCode: require('../../assets/images/report/report-code.png'),
            curTab: 1,
            tabList: [
                {tabId: 1, text: '年运综述'},
                {tabId: 2, text: '天赋能力变化'},
                {tabId: 3, text: '详细月运'},
                {tabId: 4, text: '大运轨迹'},
            ]
        }
    },
    mounted() {
        this.$bus.on('updateYearReportTab', this.updateYearReportTab);
        setTimeout(() => {
            window.scrollTo(0, 0);
            this.$store.dispatch('user/checkVipYearUpStatus');
            this.initData();
            this.initDom();
        }, 20);
    },
    destroyed() {
        this.$bus.off('updateYearReportTab', this.updateYearReportTab);
    },
    methods: {
        initData() {
            var detailInfo = this.$store.state.detail.personInfo;
            if(!detailInfo.id) {
                this.$router.replace('/record');
                return;
            }
        },
        initDom() {
            YEAR_DOM.initYearPageHeightList();
            setTimeout(() => {
                YEAR_DOM.bindYearScrollEvent();
            }, 20);
        },
        clickTopYear(yearData) {
            console.log('clickTopYear-----', yearData)
            this.$store.dispatch('year/resetYearReportData');
            this.$store.dispatch('year/updateCurYearReportData', {
                year: yearData.year
            });
            setTimeout(() => {
                this.initDom();
            }, 20);
        },
        clickTopTab(tabId) {
            this.curTab = tabId;
            YEAR_DOM.updateYearScrollTopByTab(tabId);
        },
        updateYearReportTab(tabId) {
            if(tabId == this.curTab) {
                return;
            }
            this.curTab = tabId;
        },
        clickDeepSeek() {
            var detailInfo = this.$store.state.detail.personInfo;
            console.log('clickDS', detailInfo);
            if(!detailInfo.id) {
                this.$router.replace('/record');
                return;
            }
            if(this.showTips) {
                window.localStorage.setItem('h5_fate_ds_year_tips', 1);
                this.showTips = false;
            }
            this.$showDeepSeek({
                id: detailInfo.id, type: 1
            });
        },
    }
}
</script>